class ComparisonTableScroll extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-comparison-scroll]');
    this.bar = this.querySelector('[data-comparison-scrollbar]');
    this.thumb = this.querySelector('[data-comparison-scrollbar-thumb]');
    if (!this.viewport || !this.bar || !this.thumb) return;

    this.update = this.update.bind(this);
    this.viewport.addEventListener('scroll', this.update, { passive: true });
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.viewport);
    } else {
      window.addEventListener('resize', this.update);
    }

    requestAnimationFrame(this.update);
  }

  disconnectedCallback() {
    if (this.viewport) this.viewport.removeEventListener('scroll', this.update);
    if (this.ro) this.ro.disconnect();
    else window.removeEventListener('resize', this.update);
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
    const overflow = scrollWidth - clientWidth;

    if (overflow <= 1) {
      this.bar.hidden = true;
      return;
    }
    this.bar.hidden = false;

    const trackWidth = this.bar.clientWidth;
    if (trackWidth <= 0) return;

    const visibleRatio = clientWidth / scrollWidth;
    const thumbWidth = Math.max(40, Math.round(visibleRatio * trackWidth));
    const maxOffset = trackWidth - thumbWidth;
    const progress = Math.min(1, Math.max(0, scrollLeft / overflow));
    const offset = Math.round(progress * maxOffset);

    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${offset}px)`;
  }
}

if (!customElements.get('comparison-table-scroll')) {
  customElements.define('comparison-table-scroll', ComparisonTableScroll);
}
